import BitacoraForm from "../Forms/BitacoraForm";
import FormSection from "../Sections/FormSection";

export default function TabBitacora() {

    return (
        <FormSection title="Cambiar Cliente">
            <BitacoraForm />
        </FormSection>
    );
}